import PropTypes from 'prop-types';

import {
  ChildrenDefaultProps,
  ChildrenPropTypes,
} from '@/common/proptypes/Base/Children.proptypes';
import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const InfiniteScrollItemWrapperDefaultProps = {
  ...ChildrenDefaultProps,
  ...ClassNameDefaultProps,
  context: '',
  page: null,
  sku: '',
  wrapperObserver: null,
};

export const InfiniteScrollItemWrapperPropTypes = {
  ...ChildrenPropTypes,
  ...ClassNamePropTypes,
  context: PropTypes.string,
  page: PropTypes.number,
  sku: PropTypes.string,
  wrapperObserver: PropTypes.instanceOf(IntersectionObserver),
};
